import { createFileRoute } from '@tanstack/react-router';

import { PatientsPage } from '@/app/patients/patients-page';

export const Route = createFileRoute('/patients/')({
  component: PatientsPage,
});
